<template>
    <div>
        <l-map ref="myMap" :style="`height: 30vh; width: ${width}`" :zoom="zoom" :center="center">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker v-if="this.id === 1 && myMarker.latitude" :lat-lng="myCoordinates" :clickable="true" :draggable="true" @dragend="setMarker($event, 1)"></l-marker>
            <l-marker v-if="this.id === 2 && myMarker2.latitude" :lat-lng="myCoordinates" :clickable="true" :draggable="true" @dragend="setMarker($event, 2)"></l-marker>
        </l-map>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  name: 'ResidenceMap',
  props: {
    id: {
      type: Number,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 10,
      center: [35.950294, 14.384528],
      refId: null
    }
  },
  computed: {
    ...mapGetters({
      myMarker: 'myMarker',
      myMarker2: 'myMarker2'
    }),
    myCoordinates () {
      if (this.id === 1) {
        return [this.myMarker.latitude, this.myMarker.longitude]
      } else if (this.id === 2) {
        return [this.myMarker2.latitude, this.myMarker2.longitude]
      }
      return [0, 0]
    }
  },
  methods: {
    ...mapMutations({
      updateMyMarkerValues: 'UPDATE_MY_MARKER_VALUES',
      updateMyMarker2Values: 'UPDATE_MY_MARKER_2_VALUES'
    }),
    setMarker (position, id) {
      if (Number.isNaN(position.lat) || Number.isNaN(position.lng)) return
      if (position.hasOwnProperty('target')) {
        let result = {
          latitude: position.target._latlng ? position.target._latlng.lat : position.lat,
          longitude: position.target._latlng ? position.target._latlng.lng : position.lng
        }
        this.$emit('validateBoundaries', { result, addressIdentifier: id })
      } else {
        let result = {
          latitude: position.latLng ? position.latLng.lat() : position.lat,
          longitude: position.latLng ? position.latLng.lng() : position.lng
        }
        this.$emit('validateBoundaries', { result, addressIdentifier: id })
      }
    }
  },
  watch: {
    myMarker: {
      handler (newVal) {
        if (this.id === 1 && newVal.latitude !== null) {
          const map = this.$refs.myMap.mapObject
          let newLocation = [newVal.latitude, newVal.longitude]
          var zoomlvl = 14
          map.setView(newLocation, zoomlvl)
        }
      },
      deep: true
    },
    myMarker2: {
      handler (newVal) {
        if (this.id === 2 && newVal.latitude !== null) {
          const map = this.$refs.myMap.mapObject
          let newLocation = [newVal.latitude, newVal.longitude]
          var zoomlvl = 14
          map.setView(newLocation, zoomlvl)
        }
      },
      deep: true
    }
  }
}
</script>
